import produce from "immer"
import { ASC } from "const"
import { MtStudy } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initStudy: MtStudy = {
    id: null,
    projectId: null,
    name: "",
    description: "",
    dateStart: null,
    dateEnd: null,
    managerId: null,
    systemStageId: null,
    statusId: null,
    location: "",
    site: "",
    plant: "",
    group: "",
    unit: "",
    subUnit: "",
}

const initStudyState: types.StudyState = {
    baseRoute: null,

    studyList: {},
    studyIds: [],
    studyView: initStudy,
    studyEdit: initStudy,

    sortColumn: "createdAt",
    sortOrder: ASC,
    filters: {
        search: null,
    },

    reloadList: true,
    reloadView: true,
    reloadEdit: true,
}

const studyReducer = produce((
    draft: types.StudyState = initStudyState,
    action: ActionTypes = null,
): types.StudyState => {
    switch (action.type) {
        case types.STUDY_BASE_ROUTE:
            draft.baseRoute = action.baseRoute
            return draft

        case types.STUDY_LIST:
            draft.studyList = action.studyList
            return draft

        case types.STUDY_IDS:
            draft.studyIds = action.studyIds
            return draft

        case types.STUDY_VIEW:
            draft.studyView = action.study
            return draft

        case types.STUDY_EDIT:
            draft.studyEdit = action.study
            return draft

        case types.STUDY_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.STUDY_FILTERS:
            draft.filters = action.filters
            return draft

        case types.STUDY_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.STUDY_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        case types.STUDY_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default studyReducer
